import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from "react-redux";
import store from "./Store";
import './App.css';
import { HelmetProvider } from 'react-helmet-async';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
<Provider store={store}>
  <HelmetProvider>
    <App />
  </HelmetProvider>
</Provider>
);

